const formatSessionMetadata = (sessionMetadata: unknown): string | null => {
  if (sessionMetadata == null) return null;

  if (typeof sessionMetadata === 'string') {
    return sessionMetadata;
  }

  if (typeof sessionMetadata === 'object') {
    if (Array.isArray(sessionMetadata) && sessionMetadata.length === 0) {
      return null;
    }

    if (
      !Array.isArray(sessionMetadata) &&
      Object.keys(sessionMetadata).length === 0
    ) {
      return null;
    }

    return JSON.stringify(sessionMetadata, null, 2);
  }

  return String(sessionMetadata);
};

export const OrderMetadata = ({
  sessionMetadata
}: {
  sessionMetadata?: unknown;
}) => {
  const metadataText = formatSessionMetadata(sessionMetadata);

  if (metadataText == null) return null;

  return (
    <div className="flex flex-col gap-4 p-6 pb-8 border border-base-sidebarBorder rounded-lg">
      <h2 className="font-medium text-xl text-base-primary">Metadata</h2>
      <pre
        className="m-0 whitespace-pre-wrap break-words font-sans text-sm text-base-primary"
        data-testid="orderMetadata"
      >
        {metadataText}
      </pre>
    </div>
  );
};
